import { appInfo } from './app';
import type { AppLayoutSettings } from './preferences';

const defaultSettings: AppLayoutSettings = {
  themeMode: 'light',
  navigationMode: 'side',
  menuType: 'single',
  timeZone: 'Asia/Shanghai',
  navTheme: 'light',
  colorPrimary: appInfo.primaryColor,
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  colorWeak: false,
  title: appInfo.name,
  splitMenus: false,
  siderMenuType: 'sub',
};

export default defaultSettings;
